<template>
  <div class="menu">
    <div class="top"></div>
    <van-nav-bar
      title="菜单"
      :fixed="true"
    >
      <template #right>
        <van-icon
          name="search"
          size="24"
          color="#0c34ba"
          @click="showPopup"
        />
      </template>
    </van-nav-bar>
    <van-popup
      v-model="popupshow"
      position="top"
      :style="{ height: '100%' }"
    >
    <div class="top"></div>
      <div class="popup-box">
        <van-search
          v-model="value"
          placeholder="请输入搜索关键词"
          show-action
          @input="getSearchproducts"
        >
          <template #action>
            <div @click="onCancel">取消</div>
          </template>
        </van-search>
      </div>
      <div class="product-box search-pro clearfix">
        <div
          class="product-item fl"
          :class="[index % 2 == 0 ? 'p-left' : 'p-right']"
          v-for="(item,index) in searchProducts"
          :key="index"
        >
          <div
            class="p-img"
            @click="viewProductInfo(item.pid)"
          >
            <img
              class="auto-img"
              :src="item.smallImg"
              alt=""
            >
          </div>
          <div class="pro-name one-text">{{item.name}}</div>
          <div class="clearfix">
            <div class="en-pro-name one-text fl">{{item.enname}}</div>
            <div class="pro-price fl">{{item.price}}</div>
          </div>
        </div>
      </div>
    </van-popup>

    <div class="scroll-box">
      <div class="main">
        <div class="banner-box">
          <van-swipe
            class="my-swipe"
            :autoplay="3000"
            indicator-color="#0C34BA"
          >
            <van-swipe-item>
              <div class="first-img bannerimg"></div>
            </van-swipe-item>
            <van-swipe-item>
              <div class="second-img bannerimg"></div>
            </van-swipe-item>
            <van-swipe-item>
              <div class="third-img bannerimg"></div>
            </van-swipe-item>
            <van-swipe-item>
              <div class="fourth-img bannerimg"></div>
            </van-swipe-item>
            <van-swipe-item>
              <div class="fifth-img bannerimg"></div>
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="menu-box">
          <div
            class="menu-list clearfix"
          >
            <div
              :ref="'menu' + index"
              class="menu-list-item fl"
              v-for="(item,index) in typeData"
              :key="index"
              @click="toggleType(item)"
            >
              <div class="menu-content">
                <div class="img-box">
                  <img
                    class="auto-img"
                    :src="item.isActive ? item.activeIcon : item.icon"
                    alt=""
                  >
                </div>
                <div
                  class="text"
                  :class="{active: item.isActive}"
                >{{item.typeDesc}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="menu-product">
          <div
            class="product-list"
            :class="{'not-first':index>0}"
            v-for="(item,index) in products"
            :key="index"
          >
            <div class="pro-box">
              <div
                class="pro-img"
                @click="viewProductInfo(item.pid)"
              >
                <img
                  class="auto-img"
                  :src="item.smallImg"
                  alt=""
                >
              </div>
              <div
                class="pro-info"
                @click="viewProductInfo(item.pid)"
              >
                <div class="pro-text">
                  <div class="ch-name">{{item.name}}</div>
                  <div></div>
                  <div class="en-name">{{item.enname}}</div>
                </div>
                <div class="pro-price">￥{{item.price}}</div>
              </div>
              <div class="pro-add">
                <van-icon
                  name="add"
                  color="#0C34BA"
                  size="30"
                  @click="getProductByPid(item.pid)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-popup
      v-model="productpopup"
      round
      closeable
      position="bottom"
    >
      <div class="proPopup-box">
        <h3>{{product.name}}</h3>
        <div class="specs">规格</div>
        <div class="detail-info">
          <div class="rule-box">
            <div
              class="rule-item clearfix"
              v-for="(item,index) in product.rules"
              :key="index"
            >
              <div class="rule-item-title fl">{{item.title}}</div>
              <div class="fl clearfix">
                <div
                  class="rule-item-tag fl"
                  :class="{active: v.isActive}"
                  v-for="(v,i) in item.rules"
                  :key="i"
                  @click="toggleRule(v,index)"
                >{{v.title}}</div>
              </div>
            </div>
          </div>
          <div class="desc-price-count clearfix">
            <div class="price fl">￥{{product.price}}</div>
            <div class="count fr">
              <van-stepper
                v-model="count"
                theme="round"
                button-size="22"
                disable-input
                color="#fff"
              />
            </div>
          </div>
          <div class="btn-box">
            <van-button
              icon="plus"
              type="primary"
              @click="addShopbag"
            >加入购物袋</van-button>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import "../../assets/less/menu.less";
import { utils } from "../../assets/js/Utils";
export default {
  // 组件名称
  name: "Home",
  inject: ["reload"],
  data() {
    return {
      width: 0,

      // 搜索弹出层
      popupshow: false,

      // 搜索框的值
      value: "",

      // 搜索商品
      searchProducts: [],

      typeData: [],
      products: [],

      // 商品规格弹出层
      productpopup: false,
      pid: "",
      count: 0,
      product: {},
      bagcount: 0,
    };
  },
  created() {
    // 获取商品类型数据
    this.getTypeData();
  },
  methods: {
    // 弹出搜索层
    showPopup() {
      this.popupshow = true;
    },

    // 关闭搜索弹出层
    onCancel() {
      this.popupshow = false;
      this.value = "";
      this.searchProducts = [];
    },

    // 获取商品类型数据
    getTypeData() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });
      this.axios({
        methods: "GET",
        url: "/type",
        // 如果是get请求，参数需要放在params，如果是post请求，参数需要放在data
        params: {
          appkey: this.appkey,
        },
      })
        .then((result) => {
          this.$toast.clear();

          if (result.data.code == 400) {
            let iconData = [
              {
                type: "latte",
                icon: require("../../assets/images/icons_05.gif"),
                activeIcon: require("../../assets/images/icons_19.gif"),
              },
              {
                type: "coffee",
                icon: require("../../assets/images/icons_03.gif"),
                activeIcon: require("../../assets/images/icons_18.gif"),
              },
              {
                type: "rena_ice",
                icon: require("../../assets/images/icons_07.gif"),
                activeIcon: require("../../assets/images/icons_20.gif"),
              },
              {
                type: "fruit_tea",
                icon: require("../../assets/images/icons_11.gif"),
                activeIcon: require("../../assets/images/icons_22.png"),
              },
            ];
            result.data.result.map((v) => {
              for (let i = 0; i < iconData.length; i++) {
                if (v.type == iconData[i].type) {
                  v.icon = iconData[i].icon;
                  v.activeIcon = iconData[i].activeIcon;
                  v.isActive = false;
                  break;
                }
              }
            });
            result.data.result.unshift({
              type: "isHot",
              typeDesc: "推荐",
              icon: require("../../assets/images/icons_09.gif"),
              activeIcon: require("../../assets/images/icons_21.gif"),
              isActive: true,
            });
            this.typeData = result.data.result;

            // 根据商品类型获取商品数据
            this.getProductsByType(this.typeData[0]);

            this.$nextTick(() => {
              //
              let width = this.$refs.menu0[0].clientWidth;
              //

              this.width = this.typeData.length * width;
            });
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 切换商品类型
    toggleType(item) {
      if (item.isActive) {
        return;
      }
      for (let i = 0; i < this.typeData.length; i++) {
        if (this.typeData[i].isActive) {
          this.typeData[i].isActive = false;
          break;
        }
      }
      item.isActive = true;

      // 根据商品类型获取商品数据
      this.getProductsByType(item);
    },

    // 根据商品类型获取商品数据
    getProductsByType(item) {
      this.products = [];

      // 如果存在缓存数据，则在缓存获取数据，不发起请求
      let data = sessionStorage.getItem(item.type);
      if (data) {
        this.products = JSON.parse(data);
        return;
      }

      let params = {
        key: "type",
        value: item.type,
        appkey: this.appkey,
      };

      if (item.type == "isHot") {
        params.key = "isHot";
        params.value = 1;
      }
      //

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });
      this.axios({
        methods: "GET",
        url: "/typeProducts",
        // 如果是get请求，参数需要放在params，如果是post请求，参数需要放在data
        params,
      })
        .then((result) => {
          this.$toast.clear();

          if (result.data.code == 500) {
            this.products = result.data.result;

            // 将商品数据缓存
            sessionStorage.setItem(item.type, JSON.stringify(this.products));
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 查看商品详情
    viewProductInfo(pid) {
      this.$router.push({ name: "Detail", query: { pid } });
    },

    // 搜索商品
    getSearchproducts() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });
      this.axios({
        methods: "GET",
        url: "/search",
        params: {
          appkey: this.appkey,
          name: this.value,
        },
      })
        .then((result) => {
          this.$toast.clear();
          if (result.data.code == "Q001") {
            this.searchProducts = result.data.result;
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 根据商品pid获取商品数据
    getProductByPid(pid) {
      // 弹出商品规格层
      this.productpopup = true;

      this.pid = pid;

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });

      this.axios({
        method: "GET",
        url: "/productDetail",
        params: {
          appkey: this.appkey,
          pid,
        },
      })
        .then((result) => {
          this.$toast.clear();

          if (result.data.code == 600) {
            // 处理商品描述数据
            result.data.result[0].desc = result.data.result[0].desc.split(/\n/);

            let ruleItems = ["tem", "sugar", "cream", "milk"];
            let rulesData = [];
            ruleItems.map((v) => {
              if (result.data.result[0][v] == "") {
                return;
              }

              let rule = {
                title: result.data.result[0][v + "_desc"],
                rules: [],
              };
              let r = result.data.result[0][v].split("/");
              r.map((value, index) => {
                let o = {
                  title: value,
                  isActive: index == 0,
                };
                rule.rules.push(o);
              });
              rulesData.push(rule);
            });
            result.data.result[0].rules = rulesData;

            this.product = result.data.result[0];

            //
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 切换规格
    toggleRule(v, index) {
      if (v.isActive) {
        return;
      }
      let ruleData = this.product.rules[index].rules;
      for (let i = 0; i < ruleData.length; i++) {
        if (ruleData[i].isActive) {
          ruleData[i].isActive = false;
          break;
        }
      }
      v.isActive = true;
    },

    // 加入购物袋
    addShopbag(isBuy) {
      // 获取token字符串
      let tokenString = localStorage.getItem("TK");
      if (!tokenString) {
        return this.$router.push({ name: "Login" });
      }

      // 获取选择的规格
      let rules = this.product.rules;

      let rule = [];
      rules.map((v) => {
        for (let i = 0; i < v.rules.length; i++) {
          if (v.rules[i].isActive) {
            rule.push(v.rules[i].title);
            break;
          }
        }
      });
      // 序列化参数
      let data = utils.queryString({
        appkey: this.appkey,
        tokenString,
        pid: this.pid,
        count: this.count,
        rule: rule.join("/"),
      });

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });
      this.axios({
        method: "POST",
        url: "/addShopcart",
        data,
      })
        .then((result) => {
          this.$toast.clear();

          this.$toast(result.data.msg);

          if (result.data.code == 3000) {
            this.reload();

            if (isBuy === true) {
              // 立即购买
              setTimeout(() => {
                this.$router.push({
                  name: "Pay",
                  query: { sids: result.data.sid },
                });
              }, 600);
            }
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },
  },
};
</script>
